import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { ClientRequest, ClientResponse } from '../../client.model';
import {SHARED_UTILS} from '@shared/modules/shared-utils.module';

@Component({
  selector: 'client-form',
  imports: [ReactiveFormsModule, ...SharedMaterialUIModule],
  templateUrl: './client-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientFormComponent {
  private readonly formBuilder = inject(FormBuilder);
  readonly utils = SHARED_UTILS();
  readonly title = input('Client form');
  readonly submitLabel = input('Save');
  readonly busy = input(false);
  readonly readOnly = input(false);
  readonly initialValue = input<ClientResponse | null>(null);
  readonly canToggleActive  = input<boolean>(false);
  readonly clientIsBusy = input<boolean>(false);

  readonly submitted = output<ClientRequest>();
  readonly deactivateAction = output<string>();

  readonly clientForm = this.formBuilder.group({
    name: ['', Validators.required],
  });

  constructor() {
    effect(() => {
      this.clientForm.reset({ name: this.initialValue()?.name ?? '' });
    });
  }

  protected submit(): void {
    if (this.clientForm.invalid) {
      this.clientForm.markAllAsTouched();
      return;
    }

    this.submitted.emit({ name: this.clientForm.getRawValue().name?.trim() ?? '' });
  }
}
